export default __webpack_public_path__ + "static/media/bulletin-notice.3f196538.svg";